<template>
  <div class="dna">
    <el-row justify="center">
      <el-col :span="17" align="center">
        <div class="dna-call mt-5">
          <div v-html="data.call"></div>
        </div>
      </el-col>
    </el-row>
    <el-row justify="center">
      <el-col :span="24" align="center" >
        <div class="dna-conteiner">
          <div class="dna-icons mt-5">
            <el-row justify="center" >
              <el-col :span="24" align="left" class="one">
                <figure>
                  <img src="../../assets/images/dna/cliente-icon.png" alt="" @click="openSection('Cliente')">
                </figure>
                <span>CLIENTE NO CENTRO</span>
              </el-col>
            </el-row>
            <el-row justify="center" class="two">
              <el-col :span="24" align="right">
                <figure>
                  <img src="../../assets/images/dna/proximidade-icon.png" @click="openSection('Proximidade')" alt="">
                </figure>
                <span>PROXIMIDADE E CONFIANÇA</span>
              </el-col>
            </el-row>
            <el-row justify="center" class="tree">
              <el-col :span="24" align="left">
                <figure>
                  <img src="../../assets/images/dna/performance-icon.png" @click="openSection('Performance')" alt="">
                </figure>
                <span>PERFORMANCE DE IMPACTO</span>
              </el-col>
            </el-row>
            <el-row justify="center" class="four">
              <el-col :span="24" align="right">
                <figure>
                  <img src="../../assets/images/dna/aprender-icon.png" @click="openSection('Aprender')" alt="">
                </figure>
                <span>ENSINAR, APRENDER E... REAPRENDER</span>
              </el-col>
            </el-row>
            <el-row justify="center" class="five">
              <el-col :span="24" align="left">
                <figure>
                  <img src="../../assets/images/dna/comunicacao-icon.png" @click="openSection('Comunicacao')" alt="">
                </figure>
                <span>COMUNICAÇÃO CONSCIENTE</span>
              </el-col>
            </el-row>
            <el-row justify="center" class="six">
              <el-col :span="24" align="right">
                <figure>
                  <img src="../../assets/images/dna/pixeon-con.png" @click="openSection('Pixeon')" alt="">
                </figure>
                <span>SOMOS PIXEON</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>

    <el-row justify="center" class="ebook mb-5">
      <el-col :span="24" align="center">
        <el-button round ><a href="https://bit.ly/33B2PCa" target="blank">E-book DNA da liderança</a></el-button>
      </el-col>
    </el-row>

    <el-dialog v-model="dialogVisible" width="70%"  top="50px" modal class="dialogSection">
      <component v-if="selectedSection" :is="selectedSection" :data="data"></component>
    </el-dialog>
  </div>

</template>

<script>
import axios from 'axios'
import { ref, onBeforeMount } from 'vue'
import { firebaseRoutes } from '../../config/firebase.conf'
import Aprender from './aprender/Aprender.vue'
import Cliente from './cliente/Cliente.vue'
import Comunicacao from './comunicacao/Comunicacao.vue'
import Performance from './performance/Performance.vue'
import Pixeon from './pixeon/Pixeon.vue'
import Proximidade from './proximidade/Proximidade.vue'

export default {
  name: 'Dna',
  components: {
    Aprender,
    Cliente,
    Comunicacao,
    Performance,
    Pixeon,
    Proximidade
  },
  setup () {
    const dialogVisible = ref(false)
    const selectedSection = ref('')
    const data = ref({})

    const openSection = (value) => {
      dialogVisible.value = true
      selectedSection.value = value
    }

    onBeforeMount(async () => {
      data.value = await axios.get(firebaseRoutes.dna).then((response) => {
        const result = []
        for (const id in response.data) {
          result.push({
            id: id,
            call: response.data[id].call,
            img1: response.data[id].img1,
            img2: response.data[id].img2,
            img3: response.data[id].img3,
            img4: response.data[id].img4,
            img5: response.data[id].img5,
            img6: response.data[id].img6
          })
        }
        return result[0]
      })
    })

    return {
      data,
      dialogVisible,
      openSection,
      selectedSection
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
@import "~@/styles/mixin.scss";

.dna {
  background: url(../../assets/images/dna/bg.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.dna {
  .dna-conteiner {
    position: relative;
    background-color: red;
    width: 500px;
    height: 500px;
    background: url(../../assets/images/dna/dna.png) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
  }
}

.dna-icons {
  color: orangered
}

.one {
  cursor: pointer;
  position: relative;
  top: 7rem;
  margin-left: 18rem;
  img {
    height: 65px;
  }

  span {
    position: relative;
    right: 1rem;
  }
}

.two {
  cursor: pointer;
  position: relative;
  top: 6rem;
  left: 3rem;
  img {
    height: 65px;
  }

  span {
    position: relative;
    left: 3.5rem;
  }
}

.tree {
  cursor: pointer;
  position: relative;
  top: 2rem;
  left: 3rem;
  img {
    height: 65px;
  }
  span {
    position: relative;
    right: 3.5rem;
  }
}

.four {
  cursor: pointer;
  position: relative;
  top: 0;
  right: 3rem;
  img {
    height: 65px;
  }

  span {
    width: 100px;
    position: relative;
    left: 1.5rem;
    display: block;
    text-align: center;
  }
}

.five {
  cursor: pointer;
  position: relative;
  bottom: 5rem;
  right: 3rem;
  img {
    height: 65px;
  }
  span {
    position: relative;
    right: 3.5rem;
  }
}

.six {
  cursor: pointer;
  margin-right: 12rem;
  position: relative;
  bottom: 8rem;
  img {
    height: 65px;
  }
}
.ebook {
  button {
    background: paleturquoise !important;
  }

  a {
    color: $blue;
  }
  margin-bottom: 20rem;
  margin-top: 5rem;
}
</style>
